import { IIconProps } from "../types"

export default function IconUR5(props: IIconProps) {
  const width = props.size || props.width || (83 / 5) * 3
  const height = props.size || props.height || (103 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 83 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.9121 1.01965C35.7006 0.129939 40.429 0.209913 44.5777 1.73942C48.7264 3.25894 52.2852 6.21799 55.8341 10.6666C59.383 15.1051 62.9418 21.0232 66.7106 27.5412C70.4694 34.0591 74.4481 41.1668 76.9873 46.875C79.5165 52.5931 80.6062 56.9017 81.206 61.1804C81.7958 65.449 81.8857 69.6876 80.7961 73.9163C79.6965 78.1449 77.4072 82.3736 74.828 85.9324C72.2488 89.4813 69.3698 92.3604 65.391 95.1895C61.4223 98.0285 56.3439 100.818 50.6358 101.837C44.9176 102.857 38.5696 102.087 33.1114 101.158C27.6531 100.228 23.0846 99.1282 19.4458 96.9689C15.8069 94.8096 13.1078 91.6006 10.0988 87.7518C7.08973 83.8931 3.79079 79.4145 2.09133 74.2962C0.38188 69.1778 0.261918 63.4197 0.601809 56.8218C0.9417 50.2239 1.73145 42.7763 2.85109 36.0484C3.96073 29.3206 5.40027 23.3125 7.72952 18.3641C10.0588 13.4157 13.2677 9.51693 17.2865 6.64785C21.3152 3.76877 26.1336 1.90937 30.9121 1.01965Z"
        fill="white"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 2.7"
      />
    </svg>
  )
}
